<script setup lang="ts">
    import PageHeader from '../components/PageHeader.vue';
    import ManualCoaching from '../components/quality-assurance/coaching/ManualCoaching.vue';
    import { __ } from '../stores/expressions';
    import { CircleCheckIcon } from '@lucide/vue';
</script>
<template>
    <div class="page-padding">
        <PageHeader>
            <template #icon><CircleCheckIcon class="size-full" /></template>
            {{ __('coaching') }}
        </PageHeader>
        <div class="Card mt-1.5">
            <ManualCoaching />
        </div>
    </div>
</template>
